var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#737575",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.5C5.2835 4.5 4.5 5.2835 4.5 6.25V13.75C4.5 14.7165 5.2835 15.5 6.25 15.5H13.75C14.7165 15.5 15.5 14.7165 15.5 13.75V11.75C15.5 11.3358 15.8358 11 16.25 11C16.6642 11 17 11.3358 17 11.75V13.75C17 15.5449 15.5449 17 13.75 17H6.25C4.45507 17 3 15.5449 3 13.75V6.25C3 4.45507 4.45507 3 6.25 3H8.25C8.66421 3 9 3.33579 9 3.75C9 4.16421 8.66421 4.5 8.25 4.5H6.25ZM10.5 3.75C10.5 3.33579 10.8358 3 11.25 3H16.25C16.6642 3 17 3.33579 17 3.75V8.75C17 9.16421 16.6642 9.5 16.25 9.5C15.8358 9.5 15.5 9.16421 15.5 8.75V5.56066L11.7803 9.28033C11.4874 9.57322 11.0126 9.57322 10.7197 9.28033C10.4268 8.98744 10.4268 8.51256 10.7197 8.21967L14.4393 4.5H11.25C10.8358 4.5 10.5 4.16421 10.5 3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.94662c5d.svg";
export { ForwardRef as ReactComponent };